import { usePermissions } from "components/context/permissionsContext";

export const useCustomerPermission = () => {
  const { userPermissions } = usePermissions();

  const hasSavePermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "Customer" &&
      item.action === "SaveCustomer" &&
      item.hasPermission
  );
  const hasGetPermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "Customer" &&
      item.action === "GetCustomer" &&
      item.hasPermission
  );
  const hasSaveIndividualPermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "Customer" &&
      item.action === "SaveIndividual" &&
      item.hasPermission
  );
  const hasDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "Customer" &&
      item.action === "DeleteCustomer" &&
      item.hasPermission
  );

  const PermissionProps = {
    hasSavePermission,
    hasGetPermission,
    hasSaveIndividualPermission,
    hasDeletePermission,
  };

  return {
    PermissionProps,
  };
};
